import { ElectricBillFeatures } from 'features';
import React from 'react';

const ElectricBillPage = () => {
  return <ElectricBillFeatures />;
};

export default ElectricBillPage;
